import React from 'react';

import links from '../../../config/links';
import Img from '../Img';
import SupportLink from '../Links/SupportLink';

const StripeSetup = (props) => {
    const {
        stripeIsSetUp,
        activePaymentsEnabled,
        error,
        isOwner,
        handleSetupClick,
    } = props;

    return (
        <div className={`col-12 mt24`}>
            <div className="row">
                <div className="col-12 text-center">
                    <div className="payment-provider-wrapper p16">
                        {(stripeIsSetUp && activePaymentsEnabled) ? (
                            <div className="payment-provider-linked">
                                <Img className="payment-provider-logo mb16 w-100" src="/img/logos/stripe_logo.svg" />
                                <div className="text-teal mb16">Perfect! Your account is linked.</div>
                            </div>
                        ) : (
                            <React.Fragment>
                                {error ? (
                                    <div className="payment-provider-linked">
                                        <Img className="payment-provider-logo mb16 w-100" src="/img/logos/stripe_logo.svg" />
                                        <div className="text-teal mb16">You account could not be linked. Please contact <SupportLink>support team</SupportLink> for assistance.</div>
                                    </div>
                                ) : (
                                    <Img className="payment-provider-logo mb16 w-100" src="/img/logos/stripe_logo.svg" />
                                )}
                            </React.Fragment>
                        )}

                        {error && <p className={`text-error`}>Error: {error}</p>}

                        <button
                            type="button"
                            disabled={(stripeIsSetUp && activePaymentsEnabled) || !isOwner}
                            className={`btn btn-primary btn-xl text-uppercase btn-block`}
                            onClick={handleSetupClick}
                        >
                            {(stripeIsSetUp && activePaymentsEnabled) ? 'Account Linked' : `Set up Stripe`}
                        </button>
                    </div>
                </div>
            </div>
            {!stripeIsSetUp && (
                <div className="row">
                    <div className="col-10 offset-1 fs14">
                        <div className="wizard-tip mt24">
                            Tip: You need the following information:
                            <ul>
                                <li>SSN/EIN (if business)</li>
                                <ul>
                                    <li>SSN/EIN are required in the United States, you may need a similar ID/info for the nation you are in</li>
                                </ul>
                                <li>Business Controller & Business Owner Details</li>
                                <li>Business Banking Information (Account #, Routing #)</li>
                            </ul>
                            <a href={links.stripeOrganizerFaq} target="_blank" rel="noopener noreferrer">Learn more</a>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default StripeSetup;
